'use es6';

import { useLocation } from 'react-router-dom';

var useQuery = function useQuery() {
  var location = useLocation();
  var search = location.search;
  if (!search) return {};
  var params = search.slice(1);
  return params.split('&').reduce(function (result, param) {
    var values = param.split('=');
    result[values[0]] = values[1];
    return result;
  }, {});
};

export default useQuery;